var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWebTariffSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 51,
  height: 68,
  viewBox: "0 0 51 68",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.08004 0C1.82672 0 3.8147e-05 1.93022 3.8147e-05 4.31126V63.5912C3.8147e-05 65.9722 1.82672 67.9024 4.08004 67.9024H7.40326H35.7H46.92C49.1733 67.9024 51 65.9722 51 63.5912V4.31127C51 1.93022 49.1733 0 46.92 0H4.08004Z",
  fill: "#E3E3E3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.75 55.1707C46.75 57.5145 44.8472 59.4146 42.5 59.4146H5.3125C4.72571 59.4146 4.25 58.9396 4.25 58.3536C4.25 57.7676 4.72571 57.2926 5.3125 57.2926H36.5933C37.5818 57.2926 38.25 56.1577 38.25 55.1707C38.25 52.8268 40.1527 50.9268 42.5 50.9268C44.8472 50.9268 46.75 52.8268 46.75 55.1707ZM42.5 57.2926C43.6735 57.2926 44.625 56.3426 44.625 55.1707C44.625 53.9988 43.6735 53.0487 42.5 53.0487C41.3264 53.0487 40.375 53.9988 40.375 55.1707C40.375 56.3426 41.3264 57.2926 42.5 57.2926Z"
})));
export { SvgWebTariffSmall as ReactComponent };